import config from 'constants/config'
import { normaliseAbn } from 'businessTraveller/utils/abnUtils'

// Public ABR JSON endpoint: https://abr.business.gov.au/json/
const ABR_ABN_DETAILS_URL = 'https://abr.business.gov.au/json/AbnDetails.aspx'

// ABR always wraps the JSON body in a JSONP callback, even without a callback param
const JSONP_WRAPPER = /^\s*callback\(([\s\S]*)\)\s*;?\s*$/
const NOT_FOUND_MESSAGE = /not a valid ABN/i

interface AbrAbnDetailsResponse {
  Abn: string
  AbnStatus: string
  Message: string
}

/** Resolves true when the ABN is on the register and active */
async function requestGetAbnDetails(abn: string): Promise<boolean> {
  const params = new URLSearchParams({
    abn: normaliseAbn(abn),
    guid: config.ABR_GUID ?? '',
    callback: 'callback',
  })

  const response = await fetch(`${ABR_ABN_DETAILS_URL}?${params}`)
  if (!response.ok) {
    throw new Error(`ABR lookup failed with status ${response.status}`)
  }

  const match = JSONP_WRAPPER.exec(await response.text())
  if (!match) {
    throw new Error('ABR lookup returned an unexpected response')
  }

  const data: AbrAbnDetailsResponse = JSON.parse(match[1])

  if (data.Abn) {
    return data.AbnStatus === 'Active'
  }
  if (NOT_FOUND_MESSAGE.test(data.Message)) {
    return false
  }
  // Anything else (bad GUID, service problem) is a lookup failure, not an invalid ABN
  throw new Error(data.Message || 'ABR lookup returned no ABN')
}

export default requestGetAbnDetails
